import { useEffect, useState, useRef } from 'react';
import Image from 'next/image';

/**
 * CustomImageComponent OPTIMIZADO
 *
 * Fix principal:
 * ✅ No empieza con opacity: 0 en el primer render (evita el “flash” en blanco)
 * ✅ Solo hace fade-in cuando la imagen cambia DESPUÉS del primer render
 */
const CustomImageComponent = ({
    src,
    width,
    height,
    alt = 'Imagen',
    className = '',
    style = {},
    onClick,
    unoptimized = true, // ✅ Se mantiene true para evitar edge requests
    fallbackSrc,
    priority = false,
    objectFit = 'cover',
    loading, // Permite especificar loading (lazy/eager)
    ...props
}) => {
    const defaultImage = `${process.env.NEXT_PUBLIC_IMAGES}/jugadores/0.png`;

    // ✅ Primer render: visible por defecto (evita huecos en blanco)
    const [imageSrc, setImageSrc] = useState(src || defaultImage);
    const [isLoaded, setIsLoaded] = useState(true);
    const imgRef = useRef(null);
    const isFirstRenderRef = useRef(true);

    useEffect(() => {
        // ✅ En el primer render NO hacemos fade (para no parpadear tras la hidratación)
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            setImageSrc(src || defaultImage);
            // mantenemos isLoaded = true para que se vea desde el inicio
            return;
        }

        // ✅ A partir del segundo cambio de src: fade-in normal
        setImageSrc(src || defaultImage);
        setIsLoaded(false);
    }, [src, defaultImage]);

    const handleError = () => {
        console.warn(`⚠️ Error cargando la imagen: ${src}`);
        setImageSrc(fallbackSrc || defaultImage);
        // Si falla, marcamos como cargada para evitar que se quede transparente
        setIsLoaded(true);
    };

    const handleLoad = () => {
        setIsLoaded(true);
    };

    // ✅ Determinar loading strategy
    const loadingStrategy = loading || (priority ? 'eager' : 'lazy');
    const opacity = isLoaded ? 1 : 0;

    return (
        <Image
            ref={imgRef}
            src={imageSrc}
            width={width}
            height={height}
            alt={alt}
            className={className}
            style={{
                ...style,
                objectFit,
                opacity,
                transition: 'opacity 0.3s ease-in-out', // Fade-in suave
            }}
            onClick={onClick}
            unoptimized={unoptimized}
            priority={priority}
            loading={loadingStrategy}
            onLoad={handleLoad}
            onError={handleError}
            {...props}
        />
    );
};

export default CustomImageComponent;
